import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Exciting news! <br/>
          Netcare Occhealth Care@Work has a new home. Please click the link below:
        </p>
        <a
          className="App-link"
          href="https://careatwork.oh.netcare.digital"
          target="_blank"
          rel="noopener noreferrer"
        >
          Care@Work
        </a>
      </header>
    </div>
  );
}

export default App;
